export const getSignupSourceMeta = () => {
  if (typeof navigator === "undefined") {
    return {
      signup_source_type: "Website",
      source_type: "Website",
      device_type: "Desktop"
    };
  }

  const userAgent = navigator.userAgent || "";
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/i.test(userAgent);
  const isMobile = /mobile|mobi/i.test(userAgent);

  if (isAndroid) {
    return {
      signup_source_type: "Android",
      source_type: "Android",
      device_type: "Mobile"
    };
  }

  if (isIOS) {
    return {
      signup_source_type: "IOS",
      source_type: "IOS",
      device_type: "Mobile"
    };
  }

  if (isMobile) {
    return {
      signup_source_type: "Mobile",
      source_type: "Mobile",
      device_type: "Mobile"
    };
  }

  return {
    signup_source_type: "Website",
    source_type: "Website",
    device_type: "Desktop"
  };
};
